import { useEffect, useState } from "react";
import { Row, Col, Form, Upload, Button, Input, Radio, Divider } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { avatarUploadProps, normFile, convertBase64ToPicture } from "@/lib/uploadFunction";
import { getLangList } from "@/lib/i18n";
import { modalFromLayout } from "@/lib/antdElementFunction";
import { MediaType } from './types';

type Props = {
  form: any,
  info: MediaType[],
}

function MediaModal(props: Props) {
  const { form, info } = props;
  const [mediaTypeArray, setMediaTypeArray] = useState<string[]>([]);
  const homeT: any = getLangList("home");
  const options = [
    { label: homeT.VIDEO, value: 'video' },
    { label: homeT.PICTURE, value: 'picture' },
    { label: homeT.NONE, value: 'none' },
  ];

  useEffect(() => {
    const mediaTypeArray = info.map((item: MediaType, index: number) => {
      const { url, data } = item;
      const paramIndex = index + 1;
      const mediaType = url
        ? 'video'
        : data
          ? 'picture'
          : 'none';


      form.setFieldsValue({
        [`mediaType${paramIndex}`]: mediaType,
        [`url${paramIndex}`]: url
      });
      return mediaType;
    });

    setMediaTypeArray(mediaTypeArray);
  }, [form, info]);

  const onChangeMediaType = (index: number) => (e: any) => {
    const { value } = e.target;
    const newMediaTypeArray = [...mediaTypeArray];
    newMediaTypeArray[index] = value;
    setMediaTypeArray(newMediaTypeArray);
  };

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
    >
      {info.map((item: MediaType, index: number) => {
        const { data } = item;
        const paramIndex = index + 1;
        const isVideo = mediaTypeArray[index] === 'video';
        const isNone = mediaTypeArray[index] === 'none';

        return (
          <div key={index}>
            <Form.Item label={homeT.MEDIA_TYPE} name={`mediaType${paramIndex}`}>
              <Radio.Group options={options} onChange={onChangeMediaType(index)} />
            </Form.Item>

            {isVideo && !isNone &&
              <Form.Item label={homeT.VIDEO_URL} name={`url${paramIndex}`} rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            }

            {!isVideo && !isNone &&
              <Form.Item
                label={homeT.PICTURE}
                name={`part${paramIndex}`}
                valuePropName="fileList"
                getValueFromEvent={normFile}
                tooltip={data ?
                  <Row justify="center">
                    <Col>Previous:</Col>
                    <Col><img height="200px" width="200px" alt="avatar" src={convertBase64ToPicture(data)} /></Col>
                  </Row> : null
                }
              >
                <Upload {...avatarUploadProps}>
                  <Button icon={<UploadOutlined />}>Click to Upload</Button>
                </Upload>
              </Form.Item>
            }

            {index !== 4 && <Divider dashed />}
          </div>
        );
      })}
    </Form >
  );
}

export default MediaModal;